declare let GbSdk: any;
declare global {
    interface Window {
        GbLoadInit: any;
    }
}

const gameBallData: any = () => {
    const userData = localStorage.getItem("auth_user_crocs")
        ? JSON.parse(localStorage.getItem("auth_user_crocs") || "{}")
        : null;
    const playerData = {
        displayName: userData?.name || "",
        email: userData?.email || "",
        mobile: userData?.phone || "",
    };

    return {
        userData,
        APIKey: "7e9ef2693eec49978b60f29834051603",
        loginGameBallData: {
            platform: "dokkan1",
            lang: localStorage.getItem("lang"),
            playerUniqueId: userData ? "+2" + userData?.phone : "",
            playerAttributes: userData ? playerData : {},
        },
    };
};

export function loginGameBall(): void {
    const gameBallDataBackup = gameBallData();
    if (gameBallDataBackup.userData?.phone)
        GbSdk.initReload(gameBallDataBackup.loginGameBallData);
}

export function gameBallChangeLang(lang: string): void {
    if (window.GbLoadInit) GbSdk.reloadLocal(lang);
}

export function logoutGameBall(): void {
    const gameBall = {
        playerUniqueId: "",
        platform: "dokkan1",
        playerAttributes: {},
        lang: localStorage.getItem("lang"),
    };

    if (window.GbLoadInit) GbSdk.initReload(gameBall);
}

export function gameBallInit(): any {
    const gameBallDataBackup = gameBallData();
    window.GbLoadInit = function () {
        GbSdk.init({
            platform: gameBallDataBackup.loginGameBallData.platform,
            playerUniqueId: gameBallDataBackup.loginGameBallData.playerUniqueId,
            playerAttributes:
                gameBallDataBackup.loginGameBallData.playerAttributes,
            lang: gameBallDataBackup.loginGameBallData.lang,
            APIKey: gameBallDataBackup.APIKey,
            custom: { class: "E2022", weight: 78 },
        });
    };
}
